import Typography from '@mui/material/Typography';

import background_arrow from '@/assets/simple_order/Arrow_white_title.svg';
import MapBoxMap from '@/components/Map/MapBox';
import CreateOrderForm from '@/sections/create-order/create-order-form';
import OrderSuccessModal from '@/sections/create-order/dependencies/OrderSuccessModal';
import Summary from '@/sections/create-order/summary/Summary';

import { useCreateOrderPage } from './use-create-order-page';

const CreateOrderPage = () => {
  const hooks = useCreateOrderPage();

  return (
    <div className="flex flex-col md:flex-row w-full h-auto md:h-[calc(100vh-64px)] md:-mb-8 justify-start overflow-visible md:overflow-hidden gap-4">
      {/* Sidebar Form Container */}
      <div className="h-auto md:h-full w-full md:w-[45%] min-w-[320px] md:max-w-148 overflow-hidden flex flex-col relative">
        {/* Scrollable Container */}
        <div className="flex-1 overflow-y-auto overflow-x-hidden relative flex flex-col h-full w-full">
          {/* Header Banner */}
          <div className="relative h-24 md:h-28 w-full bg-linear-to-r from-[#6ACE3B] to-[#ABDB40] overflow-hidden shrink-0">
            <div className="absolute inset-0 bg-no-repeat bg-contain bg-right z-0" />
            <div className="relative flex items-center w-[95%] h-full mx-auto z-10">
              <img src={background_arrow} alt="arrow" className="h-4 w-4 mx-3 md:mr-2 md:ml-4" />
              <div className="text-white flex flex-row items-center">
                <Typography
                  variant="h4"
                  component="h1"
                  sx={{
                    color: 'white',
                    display: 'inline',
                    fontWeight: 500,
                    fontSize: { xxs: '1.5rem', sm: '1.75rem', md: '2rem' },
                  }}
                >
                  Haz un&nbsp;
                </Typography>
                <Typography
                  variant="h4"
                  component="h1"
                  sx={{
                    color: 'white',
                    display: 'inline',
                    fontWeight: 800,
                    fontSize: { xxs: '1.5rem', sm: '1.75rem', md: '2rem' },
                  }}
                >
                  envío
                </Typography>
              </div>
            </div>
          </div>

          {/* Form Section Container */}
          <div className="p-4 pb-16 flex flex-col gap-4">
            <CreateOrderForm
              getQuotation={hooks.orderHook.getQuotation}
              resetQuotation={hooks.orderHook.resetQuotation}
              resetForm={hooks.orderHook.resetForm}
              loading={hooks.orderHook.quot.loading}
              handleHasQuot={hooks.orderHook.handleHasQuot}
              getP99={hooks.orderHook.getP99}
              handleCoordinatesPoint={hooks.orderHook.handleCoordinatesPoint}
              p99Selected={hooks.orderHook.p99Selected}
              quotData={hooks.orderHook.quot.data}
              onFormChange={hooks.orderHook.setCreateData}
            />
          </div>
        </div>
      </div>

      {/* Right Content Section: Map on top, Summary below */}
      <div className="flex-1 h-auto md:h-full flex flex-col gap-4 relative w-full">
        {/* Map Section */}
        <div className="flex-1 h-[300px] md:h-auto md:min-h-[30vh] relative bg-[#E5E4E0] w-full overflow-hidden border border-slate-100">
          <MapBoxMap
            p99={hooks.orderHook.p99Data || []}
            points={hooks.orderHook.coordinatesPoint}
            center={hooks.center}
            zoom={10}
          />
        </div>

        {/* Summary Section */}
        <div className="shrink-0 w-full">
          <Summary
            data={hooks.orderHook.quot.data}
            selectedDeliveryType={hooks.orderHook.createData?.deliveryType as string | undefined}
            hasQuot={hooks.orderHook.hasQuot}
            create={hooks.orderHook.createOrder}
            loading={hooks.orderHook.loadingCreate}
            createDisabled={hooks.orderHook.createDisabled}
          />
        </div>
      </div>

      {hooks.orderHook.showSuccessModal && hooks.orderHook.orderSuccessData && (
        <OrderSuccessModal
          isOpen={hooks.orderHook.showSuccessModal}
          onClose={hooks.orderHook.handleCloseSuccessModal}
          trackingId={hooks.orderHook.orderSuccessData.trackingId}
          internalKey={hooks.orderHook.orderSuccessData.internalKey}
          isDraft={hooks.orderHook.orderSuccessData.isDraft}
          onPrintLabel={hooks.orderHook.handlePrintLabel}
          isNational={hooks.orderHook.orderSuccessData.deliveryType === 'NAL'}
        />
      )}
    </div>
  );
};

export default CreateOrderPage;
